export default __webpack_public_path__ + "static/media/common.613c9704.png";